import React, { useState } from 'react';
import loginBackground from '../../../../assets/images/login-background';
import logo from '../../../../assets/images/rio-claro-logo-colorida.svg';
import LoginFooter from '../../../components/layout/Footer/LoginFooter';
import CustomInput from '../../../components/ui/inputs/CustomInput';
import CustomButton from '../../../components/ui/buttons/CustomButton';
import { fetchWithCsrf } from '../../../utils/fetchWithCsrf';
import { useToast } from '../../../components/ui/toast/ToastContext';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetchWithCsrf('/clients/password', {
        method: 'POST',
        body: JSON.stringify({
          client: { email },
        }),
        credentials: 'same-origin',
      });

      if (res.ok) {
        addToast({ type: 'success', message: 'Instruções enviadas para seu e-mail.' });
      } else {
        const body = await res.json();
        addToast({ type: 'error', message: body.error || 'Erro ao enviar instruções.' });
      }
    } catch (err) {
      console.error(err);
      addToast({ type: 'error', message: 'Erro inesperado. Tente novamente.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${loginBackground})` }}
    >
      <div className="bg-white px-20 py-10 rounded-custom20 w-full max-w-2xl shadow-xl text-blueDarker font-jost">
        <div className="flex items-center justify-center text-center mb-8">
          <img src={logo} alt="Rio Claro Investimentos" className="w-custom240" />
        </div>

        <div className="mb-6">
          <p className="text-2xl font-semibold">Recuperar senha</p>
          <p className="text-base font-normal pt-2">Insira seu endereço de e-mail para receber instruções</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <CustomInput
            disabled={loading}
            type="email"
            label="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="flex justify-center">
            <CustomButton disabled={loading} type="submit">
              ENVIAR INSTRUÇÕES
            </CustomButton>
          </div>
        </form>

        <div className="text-center mt-5 mb-5">
          <a href="/clients/sign_in" className="font-semibold hover:opacity-80 underline">
            Voltar para o login
          </a>
        </div>

        <div className="flex items-center justify-center text-center mb-5">
          <span>
            Não possui credenciais?{' '}
            <a href="mailto:ola@humanoide.co" className="font-semibold hover:opacity-80 underline">
              Entre em contato conosco
            </a>
            .
          </span>
        </div>
      </div>
      <LoginFooter />
    </div>
  );
};

export default ForgotPassword;
